<template>
    <v-card>
        <v-tabs v-model="tab" @change="handleTabChange">
            <v-tab value="probe">Station errors</v-tab>
            <v-tab :value="sensor.id" v-for="sensor in activeProbeSensors" :key="sensor.id">{{sensor.alias}}</v-tab>
        </v-tabs>
        <v-data-table
            :footer-props="footerProps"
            :headers="headers"
            :items="activeProbeErrors"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading station errors"
            :items-per-page="10"
            :options.sync="options"
            :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
            :server-items-length="count"
        >
            <template v-slot:item.start_date="{ item }">
                <span>{{ parseDate(item.start_date) }}</span>
            </template>
            <template v-slot:item.end_date="{ item }">
                <span>{{ item.end_date ? parseDate(item.end_date) : null }}</span>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>

import {mapActions, mapMutations, mapState} from "vuex";
import moment from "moment";

export default {
    name: 'HistoryModalContent',
    props: ['activeProbeId'],
    data() {
        return {
            tab: null,
            activeErrors: [],
            activeSensor: null,
            options: this.tableOptions,
            footerProps: {"items-per-page-options": [10, 20, 50, 100]},
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Long alias',
                    align: 'start',
                    sortable: false,
                    value: 'long_alias',
                },
                {
                    text: 'Sensor',
                    align: 'start',
                    sortable: false,
                    value: 'sensor_alias',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: 'Description',
                    align: 'start',
                    sortable: false,
                    value: 'description',
                },
                {
                    text: 'Start Date',
                    align: 'start',
                    sortable: false,
                    value: 'start_date',
                },
                {
                    text: 'End Date',
                    align: 'start',
                    sortable: false,
                    value: 'end_date',
                }
            ]
        }
    },
    mounted() {
      this.handleErrorsUpdate()
    },
    beforeMount() {
        this.setTableOptions({...this.tableOptions, page: 1})
    },
    watch: {
        activeProbeId() {
            this.handleErrorsUpdate()
        },
        options(val) {
            this.setTableOptions(val)
            this.handleErrorsUpdate()
        },
    },
    computed: {
        ...mapState('sensorError', ['activeProbeErrors', 'loading', 'tableOptions', 'count', 'activeProbeSensors'])
    },
    methods: {
        ...mapActions('sensorError', ['fetchProbeErrors']),
        ...mapMutations('sensorError', ['setTableOptions']),
        parseDate(date) {
            return moment(date).format('DD-MM-YYYY HH:MM')
        },
        async handleErrorsUpdate() {
            //this.setTableOptions({...this.tableOptions, page: 1})
            await this.fetchProbeErrors({probeId: this.activeProbeId, sensorId: this.activeSensor?.id})
        },
        handleTabChange(tabNumber) {
            this.setTableOptions({...this.tableOptions, page: 1})
            this.activeSensor = this.activeProbeSensors?.[tabNumber-1]
            this.handleErrorsUpdate()
        }
    }
}

</script>

<style scoped>

</style>